/** Unwrap tool result content from various backend formats. */
export const parseToolOutput = (raw: string): string => {
  if (!raw) return "";
  try {
    const parsed = JSON.parse(raw);

    if (parsed.success !== undefined && parsed.success !== true) {
      return (
        parsed.error ||
        parsed.result?.output ||
        parsed.result?.error ||
        "Tool execution failed"
      );
    }

    if (typeof parsed.result?.output === "string") {
      return parsed.result.output;
    }

    if (typeof parsed.output === "string") {
      return parsed.output;
    }

    if (parsed.stdout !== undefined) {
      return parsed.stdout || parsed.stderr || "";
    }
  } catch {
    /* not JSON */
  }
  return raw;
};
